<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      :goback="true"
      :selectShow="false"
      :show="false"
      clickSwitch="/copymerchantInfo/up"
      :clickShow="true"
      @click="click"
      clickShowType="warning"
      clickName="更新富友费率"
    >
    </common-top-form>
    <div
      style="
        display: flex;
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 15px;
      "
    >
      <span>商户号：{{ this.impiementall.merNo || "暂无" }} </span>
      <span style="margin-left: 15px"
        >商户名：{{ this.impiementall.merName || "暂无" }}
      </span>
    </div>
    <common-table :data="tableData" ref="commonTable" :isShow="false">
      <el-table-column
        prop="busiCd"
        label="交易类型描述"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cardType"
        label="卡类型"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="fee"
        label="费率"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";

import OrganService from "service/OrganService";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "copymerchantInfoFeilv",
  components: {
    CommonTopForm,
    CommonTable,
  },
  data() {
    return {
      show: false,
      formModel: {},
      tableData: [],
      submitService: OrganService.copymerchantInfoFeilvFeilv,
      isFlag: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  created() {
    this.impiementall = JSON.parse(this.$route.params.item);
  },

  mounted() {
    this.load();
  },
  computed: {
    submitData() {
      this.params = {
        merNo: this.impiementall.merNo,
      };
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {},
  methods: {
      click() {
      this.showConfirm("是否执行操作？")
        .then(() => {
          this.doup();
        })
        .catch(() => {});
    },
     doup() {
       console.log('ww')
      this.doLoad(
        OrganService.newGengxin,
       this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    load() {
      this.formModel = {};
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result;
      });
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/CopyMerchantInfoFeilv.vue